import React from "react";
import { useEffect } from "react";
import { useApp } from "../../../contexts";
import { useState } from "react";
import { FormItem, FormSelect, FormInput } from "../../../components/Form";
import { ModalDetail } from "./ModalDetail";
import useDebounce from "../../../hook/useDebounce";
import { useWindowSize } from "../../../hook/useWindowSize";
import {
  getCollectionUrl,
  genAffByCategory,
  getPreviewData,
} from "../../../services/app";
import { ZENDESK_URLS } from "../../../constants";

const getTrackerLink = (language) => {
  switch (language) {
    case "ja":
      return ZENDESK_URLS.JA.TRACKER;
    case "ko":
      return ZENDESK_URLS.KO.TRACKER;
    case "cn":
      return ZENDESK_URLS.CN.TRACKER;
    case "tc": 
      return ZENDESK_URLS.TC.TRACKER;
    case "vi":
      return ZENDESK_URLS.VI.TRACKER;
    case "id":
      return ZENDESK_URLS.ID.TRACKER;
    case "pt":
      return ZENDESK_URLS.PT.TRACKER;
    case "es":
      return ZENDESK_URLS.ES.TRACKER;
    case "en":
    default:
      return ZENDESK_URLS.EN.TRACKER;
  }
}

export const TabCollections = (props) => {
  const size = useWindowSize();
  const { T, user, language } = useApp();
  const [collection, $collection] = useState(null);
  const [collections, $collections] = useState([]);
  const [mediaSource, $mediaSource] = useState("");
  const debouneMediaSource = useDebounce(mediaSource, 1000);
  const [linkPreview, setLinkPreview] = useState("");
  const [linkPreviewServe, setLinkPreviewServe] = useState("");
  const [errors, $errors] = useState({
    collection: '',
    mediaSource: ''
  })
  const [previewData, $previewData] = useState({});

  const [isOpenModal, $isOpenModal] = useState(false);

  useEffect(() => {
    getCollectionUrl().then((res) =>{
      const data = res.data?.data || {};
      const listOptions = [];
      for (let key in data) {
        listOptions.push(data[key])
      }
      $collections(listOptions);
    }).catch((err) => {
      $collections([]);
    })
    
  }, []);

  useEffect(() => {
    if (collection) {
      const collectionSelected = collections.find((item) => item.key === collection)
      const result = `${collectionSelected.link}${
        !collectionSelected.link.includes("?")
          ? "?oid=" +
            collectionSelected.oid +
            "&affid=" +
            user.evf_affid +
            "&sub1=" +
            mediaSource
          : "&oid=" +
            collectionSelected.oid +
            "&affid=" +
            user.evf_affid +
            "&sub1=" +
            mediaSource
      }`;
      setLinkPreview(result);
    } else {
      setLinkPreview("");
    }
  }, [collection, debouneMediaSource]);

  const handleSelectItem = (value) => {
    $collection(value);
  };
  const validateData = () => {
    let error = false;
    if (!collection || collections.filter(item => item.key == collection).length === 0) {
      $errors((prev) => ({...prev, collection: 'collection_required' }));
      error = true;
    }
    return error
  }
  const loadPreviewData = async (url) => {
    if (!url) {
      return;
    }
    try {
      const data = await getPreviewData(url);
      if (data) {
        $previewData({
          ...data,
          sitename: url
            .replace("https://", "")
            .replace("http://", "")
            .replace(".com?", ".com/")
            .replace(".jp?", ".jp/")
            .replace(".id?", ".id/")
            .replace(".vn?", ".vn/")
            .split("/")[0],
        });
      }
    }catch(err){
      console.log(err);
    }      
  };

  const generateAffLink = () => {
    if (validateData()) {
      return;
    }
    genAffByCategory({
      options: collection,
      sub1: mediaSource
    })
      .then((res) => {
        setLinkPreviewServe(res.data?.data);
        $isOpenModal(true)
      })
      .catch((err) => {
        setLinkPreviewServe('');
        $isOpenModal(false)
      });
  };

  useEffect(() => {
    loadPreviewData(linkPreview);
  }, [linkPreview]);
  
  return (
    <div className="flex flex-col lg:flex-row items-start lg:gap-[34px] xls:gap-[34px] mt-[10px]">
      <div className="w-full lg:w-[50%]">
        <div className="mb-[40px]">
          <div className="text-black font-[700] mb-[10px] text-[16px] lg:text-[15px] xls:text-[16px]">
            {T("Select a Collection")} <span className="text-[#FA2929]">*</span>
          </div>
          <div className="text-black font-[400] mb-[10px] text-[14px] lg:text-[14px] xls:text-[16px]">
            {T("Please select one collection of avatar to generate link")}
          </div>
          <FormItem>
            <FormSelect
              className="generate-select"
              allowClear={false}
              value={collection}
              onChange={(value) => {
                handleSelectItem(value);
              }}
            >
              <FormSelect.Option value={null}>
                {T("Please choose a collection")}
              </FormSelect.Option>
              {collections.map((item, index) => (
                <FormSelect.Option key={index} value={item.key}>
                  {T(`affiliate.${item.key}`)}
                </FormSelect.Option>
              ))}
            </FormSelect>
          </FormItem>
          {/* {errors.collection && <div className="error">{T(errors.collection)}</div>} */}
        </div>
        <div className="mb-[40px]">
          <div className="text-black font-[700] mb-[10px] text-[16px] lg:text-[15px] xls:text-[16px]">
            {T("Add name of media source")}
          </div>
          <div className="text-black font-[400] mb-[10px] text-[14px] lg:text-[14px] xls:text-[16px]">
            {T(
              "Please add name of the media that you are going to post the URL, i.e instagram, facebook, youtube, etc"
            )}
            <a
              href={getTrackerLink(language)}
              target="_blank"
              className="flex justify-start items-center gap-2 font-[400] mt-3 mb-6"
            >
              <span className="text-aia-red font-[400] text-[12px]">
                {T("How to use Source name")}
              </span>
              <svg
                className="w-[4.9px] ml-[10px]"
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="11"
                viewBox="0 0 6 11"
                fill="none"
              >
                <path
                  d="M1 1L2.69647 2.52682C4.23903 3.91512 5.01031 4.60928 5.01031 5.5C5.01031 6.39072 4.23903 7.08488 2.69647 8.47318L1 10"
                  stroke="black"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
            </a>
          </div>

          <FormItem>
            <FormInput
              className="generate-input"
              value={mediaSource}
              onChange={(event) => {
                $mediaSource(event.target.value);
              }}
              placeholder={T("instagram-post")}
            />
          </FormItem>
          {/* {errors.collection && <div className="error">{T(errors.collection)}</div>} */}
        </div>

        {size.width > 1024 && (
          <div>
            <button
              className="w-full lg:w-[220px] bg-black !text-white flex justify-center items-center 
          rounded-[15px] px-[20px]  py-[9px] lg:py-[11px] text-[16px] xls:text-[20px] font-[500] mb-[15px]"
              type="button"
              onClick={() => generateAffLink()}
            >
              {T("Generate link")}
            </button>
          </div>
        )}
      </div>
      <div className="w-full lg:w-[50%] ">
        {linkPreview && (
          <>
            <div className="mb-[30px]">
              <div className="text-black font-[700] mb-[10px] text-[16px] lg:text-[15px] xls:text-[16px]">
                {T("Link preview")}
              </div>
              <div className="text-aia-red font-[400] mb-[10px] text-[14px] lg:text-[14px] xls:text-[16px] break-all">
                {linkPreview}
              </div>
            </div>

            {previewData && (
              <div className="lg:ml-[12px] lg:mb-[60px] mb-[40px]">
                <div className="text-black font-[700] mb-[10px] text-[16px] flex items-center gap-2">
                  <img
                    src={"/favicon.ico"}
                    alt="favi"
                    width={"24px"}
                    onError={(event) => {
                      event.target.src = "/assets/images/favi.png";
                      event.onerror = null;
                    }}
                  />{" "}
                  <span className="">{previewData?.sitename}</span>
                </div>
                <div className="text-aia-red font-[400] mb-[10px] text-[14px]/[26px]">
                  {previewData?.title}
                </div>
                <div className="text-black font-[400] mb-[16px] text-[14px]/[26px] xls:text-[16px]/[26px]">
                  {previewData?.description}
                </div>
                {previewData?.image &&
                  !previewData?.image?.includes("favicon.png") && (
                    <div className="w-full lg:max-w-[300px]">
                      <img
                        className="w-full rounded-[8px]"
                        src={previewData?.image}
                      />
                    </div>
                  )}
              </div>
            )}
          </>
        )}
        {size.width < 1024 && (
          <div>
            <button
              className="w-full lg:w-[220px] bg-black !text-white flex justify-center items-center 
          rounded-[15px] px-[20px]  py-[9px] lg:py-[11px] text-[16px] xls:text-[20px] font-[500] mb-[15px]"
              type="button"
              onClick={() => generateAffLink()}
            >
              {T("Generate link")}
            </button>
          </div>
        )}
      </div>
      {isOpenModal && (
        <ModalDetail
          title={T("Link successfully generated")}
          linkPreviewServe={linkPreviewServe}
          onClose={() => $isOpenModal(false)}
        />
      )}
    </div>
  );
};
